import React from 'react';
import styles from './styles.module.scss';

const SliderControl = ({ label, min, max, value, onChange }) => (
    <div className={styles.sliderControl}>
        <label>{label}</label>
        <input
            type="range"
            min={min}
            max={max}
            value={value}
            onChange={(e) => onChange(Number(e.target.value))}
        />
        <span>{value}</span>
    </div>
);

export default SliderControl;
